import { relatorios } from '../utils/constants'

export default [
  {
    icon: 'mdi-monitor-dashboard',
    title: 'Início',
    to: '/gestor/dashboard',
  },
  {
    icon: 'mdi-cart-outline',
    title: 'Lançamentos',
    group: '/gestor/cdv',
    children: [
      {
        icon: 'mdi-file-document-outline',
        title: 'Movimento de Atendimento',
        to: 'atendimento',
      },
    ],
  },
  {
    icon: 'mdi-bullhorn-outline',
    title: 'Comunicações',
    group: '/gestor/ccc',
    children: [
      {
        icon: 'mdi-card-account-mail-outline',
        title: 'Mensagens Produtor',
        to: 'notificacoesProdutor/?tipo=P',
        permission: 'list_notificacao_produtor',
      },
      {
        icon: 'mdi-card-account-details-star-outline',
        title: 'Mensagens Técnico',
        to: 'notificacoesTecnico/?tipo=T',
        permission: 'list_notificacao_tecnico',
      },
    ],
  },
  {
    icon: 'mdi-package-variant-closed',
    title: 'Produtos/Serviços',
    group: '/gestor/cdc',
    children: [
      {
        icon: 'mdi-book-open-page-variant-outline',
        title: 'Catálogos',
        to: 'catalogos',
      },
      {
        icon: 'mdi-package-variant-closed',
        title: 'Produtos',
        to: 'produtos',
      },
      {
        icon: 'mdi-toolbox',
        title: 'Serviços',
        to: 'servicos',
      },
      {
        icon: 'mdi-scale-balance',
        title: 'Unidades de medida',
        to: 'unidadesmedida',
      },
      {
        icon: 'mdi-cash-multiple',
        title: 'Planos de Pagamento',
        to: 'plano-pagamento',
      },
    ],
  },
  {
    icon: 'mdi-account-details',
    title: 'Pessoas',
    group: '/gestor',
    children: [
      {
        icon: 'mdi-account-cowboy-hat',
        title: 'Produtores',
        to: 'produtores',
      },
      {
        icon: 'mdi-barn',
        title: 'Fazendas',
        to: 'fazendas',
      },
      {
        icon: 'mdi-account-hard-hat',
        title: 'Técnicos',
        to: 'tecnicos',
      },
      {
        icon: 'mdi-account-supervisor',
        title: 'Empresas Conveniadas',
        to: 'fornecedores',
      },
    ],
  },
  {
    icon: 'mdi-note-text',
    title: 'Relatórios',
    group: '/gestor/relatorio',
    children: [
            {
        icon: 'mdi-circle-medium',
        title: 'Serviços efetuados por produtor',
        subtitle: 'Produtor',
        to: relatorios.servicosProdutor,
      },
      {
        icon: 'mdi-circle-medium',
        title: 'Serviços por Técnico',
        subtitle: 'Análitico',
        to: relatorios.servicoTecnicos,
      },
      {
        icon: 'mdi-circle-medium',
        title: 'Atendimentos por Empresa',
        subtitle: 'Empresa',
        to: relatorios.atendimentoEmpresa,
      },
      {
        icon: 'mdi-circle-medium',
        title: 'Resumo dos Serviços',
        subtitle: 'Resumo',
        to: relatorios.resumoServicos,
      },
      // {
      //   icon: 'mdi-circle-medium',
      //   title: 'Serviços por Cliente',
      //   subtitle: 'Análitico',
      //   to: relatorios.vendasProdutores,
      // },
      // {
      //   icon: 'mdi-circle-medium',
      //   title: 'Produtores sem serviço no período',
      //   to: relatorios.produtoresSemCompra,
      // },
      // {
      //   icon: 'mdi-circle-medium',
      //   title: 'Fazendas por Produtor',
      //   to: relatorios.produtoresFazendas,
      // },
      // {
      //   icon: 'mdi-circle-medium',
      //   title: 'Serviços por Cliente',
      //   subtitle: 'Análitico',
      //   to: relatorios.vendasProdutores,
      // },
      // {
      //   icon: 'mdi-circle-medium',
      //   title: 'Produtores sem serviço no período',
      //   to: relatorios.produtoresSemCompra,
      // },
      // {
      //   icon: 'mdi-circle-medium',
      //   title: 'Fazendas por Produtor',
      //   to: relatorios.produtoresFazendas,
      // },
    ],
  },
]
